import { useNavigate, useParams } from 'react-router-dom';
import { useCampaignStore } from '../stores/campaignStore';
import { useVoucherStore } from '../stores/voucherStore';
import { CampaignHeader } from '../components/CampaignHeader';
import { useAnalytics } from '../hooks/useAnalytics';

export function Step0LandingPage() {
  const navigate = useNavigate();
  const { campaignSlug } = useParams<{ campaignSlug: string }>();
  const { campaign } = useCampaignStore();
  const { setCurrentStep } = useVoucherStore();
  const { trackSelectContent } = useAnalytics();

  const handleParticipate = () => {
    trackSelectContent('button', 'quero_participar', {
      eventCategory: 'step_0_landing',
      eventAction: 'avancar_step',
      eventLabel: 'botao_quero_participar',
    });
    setCurrentStep(1);
    navigate(`/${campaignSlug}/cadastro`);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <CampaignHeader />

      {/* Desktop: side-by-side | Mobile: stacked */}
      <div className="flex-1 flex flex-col lg:flex-row">
        {/* Left: Initial Image (campaign hero) */}
        <div className="lg:w-1/2 w-full">
          {campaign?.initialImageUrl ? (
            <img
              src={campaign.initialImageUrl}
              alt={campaign.name}
              className="w-full h-[45vh] lg:h-full object-cover"
            />
        ) : (
            <div className="w-full h-[45vh] lg:h-full bg-gradient-to-br from-rchlo-green to-emerald-800" />
        )}
      </div>

        {/* Right: Product info + CTA */}
        <div className="lg:w-1/2 w-full flex flex-col items-center justify-center px-6 py-10 lg:py-0">
          {/* Product Image (gift/brinde) */}
          {campaign?.productImage && (
            <img
              src={campaign.productImage}
              alt={campaign.productName}
              className="h-32 lg:h-40 object-contain mb-6"
            />
          )}

          {/* Product Name */}
          <h1 className="text-center font-bold text-gray-900 text-base lg:text-lg uppercase leading-tight max-w-sm mb-3">
            Retire seu {campaign?.productName || 'BRINDE'}
          </h1>

          {/* Description */}
          <p className="text-center text-sm text-gray-500 max-w-xs mb-8">
            Faça seu cadastro, escolha a loja e a data de resgate, e emita seu voucher digital.
          </p>

          {/* CTA Button */}
          <button onClick={handleParticipate} className="btn-primary w-full mt-8">
            Quero Participar
          </button>

        </div>
      </div>
    </div>
  );
}
